import React from "react";
import Modal from "./Modal";
import "../css/Modal.css";

const SuccessModal = ({
  isOpen,
  onClose,
  title,
  message,
  image,
  buttonLabel,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="success-modal-content">
        {image && (
          <div className="success-modal-image-container">
            <img
              src={image}
              alt="success-approved"
              className="success-modal-image"
            />
          </div>
        )}
        {title && <p className="success-modal-heading">{title}</p>}
        <p className="success-modal-subHeading">{message}</p>

        {buttonLabel && (
          <button className="success-modal-approve-button" onClick={onClose}>
            {buttonLabel}
          </button>
        )}
      </div>
    </Modal>
  );
};

export default SuccessModal;
